export default __webpack_public_path__ + "static/media/theater-app-screengrab1.3aaa4c13.png";